export default {
    ToggleShouldShowAllGroups: {
        datapoint: {
            name: 'GroupList_ToggleShouldShowAllGroups',
            customData: (isShowingAllGroups: boolean, joinedGroupCount: number) => {
                return {
                    isShowMore: !isShowingAllGroups, // true if the user clicked on "More" button to show all groups, false if the user clicked on "Less" to show less groups
                    joinedGroupCount: joinedGroupCount >= 21 ? '21+' : joinedGroupCount, // Number of groups the user would see when showing all groups. For more than 20 groups, we won't log the actual count so that we limit the unique values for this metric due to reporting limitations
                };
            },
        },
    },
};
